import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useLoginApi() {
  const { config, apiFetch } = useContext(GlobalContext);
  const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000";

  async function encryptPassword(password) {
    const response = await apiFetch(`${BASE_URL}/encrypt_password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Password encryption failed");
    }

    return data.data; // encrypted password string
  }

  async function loginCustomer({ phoneNo, encryptedPassword, userType = "user" }) {
    const response = await apiFetch(`${BASE_URL}/login_customer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phoneNo,
        password: encryptedPassword,
        userType,
      }),
    });
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Login failed");
    }

    return data;
  }

  /* ==============================
     SEND RESET OTP (Forgot Password)
  ============================== */
  async function sendResetOtp(phoneNumber) {
    const response = await apiFetch(`${BASE_URL}/send_reset_otp_users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phoneNumber }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to send OTP");
    }

    return data;
  }

  /* ==============================
     RESET PASSWORD (⭐ THIS WAS MISSING)
  ============================== */
  async function resetPassword(phoneNumber, otp, newPassword) {
    const response = await apiFetch(`${BASE_URL}/reset_password_users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phoneNumber,
        otp,
        newPassword,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Password reset failed");
    }

    return data;
  }
  /* ==============================
     RESEND RESET OTP (Forgot Password Users)
  ============================== */
  async function resendOtp(phoneNumber) {
    const response = await apiFetch(`${BASE_URL}/resend_reset_otp_users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phoneNumber }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to resend OTP");
    }

    return data;
  }


  // ✅ RETURN ALL FUNCTIONS
  return {
    resendOtp,
    encryptPassword,
    resetPassword,
    loginCustomer,
    sendResetOtp
  };

}
